import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Box, styled } from '@mui/material';
import Banner from './Banner';
import axios from '../../../utils/axios';
import { AuthContext } from '../../../contexts/JWTContext';
import AccountPendingBanner from './AccountPendingBanner';
import AccountLockedBanner from './AccountLockedBanner';
import VerifyOTP from '../AuthModal/verify-code/VerifyOTP';
import { openModal } from '../../../redux/slices/authModal';
import PendingApprovalBanner from '../../../sections/auth/PendingApprovalBanner';
import BannedUserBanner from '../../../sections/auth/BannedUserBanner';
import AccessRestrictedBanner from '../../../sections/auth/AccessRestrictedBanner';

// Blank page component that fills the entire screen
const BlankPage = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: theme.palette.background.default,
  zIndex: 1200, // Below modal but above everything else
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

// Overlay container for banned user modal
const BannedOverlay = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 1300, // Above blank page
  pointerEvents: 'none', // Allow clicks to pass through to modal
  '& > *': {
    pointerEvents: 'auto', // Re-enable clicks on modal
  },
}));

const BannerContainer = ({ children }) => {
  const [banners, setBanners] = useState([]);
  const { isAuthenticated, user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    console.log(user);
    if (user && user.isOTPVerified === false) {
      dispatch(openModal('verifyCode'));
    }
  }, [user]);

  // If user is banned, render blank page with banner overlay
  if (user && user.isBanned) {
    return (
      <>
        <BlankPage />
        <BannedOverlay>
          <BannedUserBanner
            userData={user}
            logout={handleLogout}
          />
        </BannedOverlay>
      </>
    );
  }

  // If user's access is restricted, render blank page with restriction overlay
  if (user && user.role === 'user' && user.is_access_restricted) {
    return (
      <>
        <BlankPage />
        <BannedOverlay>
          <AccessRestrictedBanner logout={handleLogout} />
        </BannedOverlay>
      </>
    );
  }

  // Normal banner container
  return (
    <>
      {/* Show pending approval banner if user is not accepted yet */}
      {user && user.role === 'user' && !user?.acceptedUser && (
        <PendingApprovalBanner
          userData={user}
          onChangeCompany={() => {
            // Handle company change logic
          }}
          logout={handleLogout}
        />
      )}

      {/* Render children (Router) */}
      {children}
    </>
  );
};

export default BannerContainer;